var React = require('react');

function Tf1LogoInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"TF1"),React.createElement("path",{"d":"M0,0v72.1h197.4V0H0z M60.5,28.3H49v32.9H27V28.3H15.5V10.9h45V28.3z M128.6,23.5h-18.9v9.3h13.5v12.6h-13.5v15.8h-22V10.9\n\th40.9V23.5z M177.5,61.2h-22.8v-44l22.8-6.5V61.2z","key":1})]);
}

Tf1LogoInline.defaultProps = {"width":"197.4","height":"72.1","viewBox":"0 0 197.4 72.1"};

module.exports = Tf1LogoInline;

Tf1LogoInline.default = Tf1LogoInline;
